"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _clsx = _interopRequireDefault(require("clsx"));

var _elements = require("../../styles/elements");

var _icons = require("../../assets/icons");

var _AppBar = require("./AppBar.styles");

var info = {
  warning: (0, _jsxRuntime.jsx)(_icons.Error, {}),
  negative: (0, _jsxRuntime.jsx)(_icons.Negative, {}),
  positive: (0, _jsxRuntime.jsx)(_icons.Note, {}),
  info: (0, _jsxRuntime.jsx)(_icons.Note, {})
};

var AppBar = function AppBar(_ref) {
  var type = _ref.type,
      className = _ref.className,
      children = _ref.children,
      onClose = _ref.onClose,
      close = _ref.close,
      closable = _ref.closable,
      roundBorder = _ref.roundBorder,
      boxShadow = _ref.boxShadow;
  var contentRef = (0, _react.useRef)();
  var handleClose = (0, _react.useCallback)(function () {
    onClose(true);
  }, [onClose]);
  return (0, _jsxRuntime.jsx)("div", {
    css: [_elements.text.styles.text3Xs, _AppBar.styles[type], !close && _AppBar.styles.show, roundBorder && _AppBar.styles.roundBorder, boxShadow && _AppBar.styles.boxShadow, process.env.NODE_ENV === "production" ? "" : ";label:AppBar;"],
    className: (0, _clsx["default"])(className, {
      close: close
    }),
    children: (0, _jsxRuntime.jsxs)("div", {
      ref: contentRef,
      children: [info[type] && (0, _jsxRuntime.jsx)("span", {
        children: info[type]
      }), (0, _jsxRuntime.jsx)("div", {
        children: children
      }), closable && (0, _jsxRuntime.jsx)("button", {
        css: _elements.button.styles.preflight,
        type: "button",
        className: "grui",
        onClick: handleClose,
        children: (0, _jsxRuntime.jsx)(_icons.Close, {})
      })]
    })
  });
};

AppBar.propTypes = {
  type: (0, _propTypes.oneOf)(['warning', 'positive', 'negative', 'info']),
  className: _propTypes.string,
  children: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.node]),
  close: _propTypes.bool,
  closable: _propTypes.bool,
  onClose: _propTypes.func,
  roundBorder: _propTypes.bool,
  boxShadow: _propTypes.bool
};
AppBar.defaultProps = {
  type: 'warning',
  className: undefined,
  children: undefined,
  close: true,
  closable: true,
  onClose: function onClose() {},
  roundBorder: false,
  boxShadow: false
};
var _default = AppBar;
exports["default"] = _default;
//# sourceMappingURL=AppBar.js.map